// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__FdaMN","header":"ReportDetails_header__1UaNc","title":"ReportDetails_title__2-qwG","left":"ReportDetails_left__3jArE"};